























import Vue from 'vue';
import { useSave } from '@/composables';
import { BaseModuleEditor } from '../base';

export default Vue.extend({
  name: 'ElementLineEditor',
  mixins: [BaseModuleEditor],
  props: {
    id: {
      type: String,
      required: true,
    },
  },
  setup(props: any) {
    const { buffer, save } = useSave(props, {
      path: 'element',
    });
    return {
      buffer,
      save,
    };
  },
});
